import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { openPurchaseDialog } from 'actions/fate';
import { closeSidebar } from 'actions/sidebar';
import Image from 'components/Image';
import getPremiumDaysRemaining from 'selectors/fate/getPremiumDaysRemaining';
import * as FatePropTypes from 'fera-prop-types/fate';

export class PlayerFate extends Component {
  handleClick = () => {
    const {
      actions,
      dispatch,
      fateCards,
      history,
    } = this.props;
    const actionsRemaining = actions;
    const actionItem = fateCards.find(({ action }) => action === 'RefillActions');

    if (actionsRemaining <= 6) {
      dispatch(openPurchaseDialog(actionItem));
    } else {
      history.push('/fate');
    }
  }

  handleClickToSubscribe = () => {
    const { dispatch } = this.props;
    dispatch(closeSidebar());
  }

  renderSubscriptionInformation = () => {
    const { isExceptionalFriend, premiumDaysRemaining } = this.props;
    if (isExceptionalFriend) {
      return (
        <div>
          {`${premiumDaysRemaining} day${premiumDaysRemaining !== 1 ? 's' : ''} left of Exceptional Friendship`}
        </div>
      );
    }
    return (
      <div>
        <h3>BE EXCEPTIONAL!</h3>
        <p>
          <Link onClick={closeSidebar} to="/fate">
            Subscribe for a second candle and brand new stories every month.
          </Link>
        </p>
      </div>
    );
  }

  render = () => {
    const { currentFate } = this.props;
    return (
      <li className="item">
        <div
          className="js-icon icon js-tt icon--currency"
          onClick={this.handleClick}
          onKeyUp={this.handleClick}
          role="button"
          tabIndex={-1}
        >
          <Image
            className="media__object"
            icon="fate"
            type="currencies"
            width={60}
            height={78}
          />
        </div>
        <div className="item__desc">
          <span className="js-item-name item__name">Fate</span>
          <div className="invert">{currentFate}</div>
          {this.renderSubscriptionInformation()}
        </div>
      </li>
    );
  }
}

PlayerFate.displayName = 'PlayerFate';

PlayerFate.propTypes = {
  actions: PropTypes.number,
  currentFate: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  fateCards: PropTypes.arrayOf(FatePropTypes.fateCard).isRequired,
  isExceptionalFriend: PropTypes.bool.isRequired,
  premiumDaysRemaining: PropTypes.number.isRequired,
};

PlayerFate.defaultProps = {
  actions: undefined,
};

const mapStateToProps = (state) => {
  const {
    actions: { actions },
    fate: {
      isExceptionalFriend,
      data: {
        currentFate,
        fateCards,
      },
    },
  } = state;
  return {
    actions,
    currentFate,
    fateCards,
    isExceptionalFriend,
    premiumDaysRemaining: getPremiumDaysRemaining(state),
  };
};

export default withRouter(connect(mapStateToProps)(PlayerFate));